{
  "branding": {
    "name": "Jumble",
    "shortName": "Jumble",
    "description": "A user-friendly Nostr client for exploring relay feeds.",
    "titleTemplate": "{page} · {name}",
    "footerText": "Jumble — an independent, relay-first Nostr client.",
    "links": [
      { "label": "What is Nostr?", "url": "https://nostr.com", "icon": "globe" },
      { "label": "NIPs", "url": "https://github.com/nostr-protocol/nips", "icon": "document" }
    ]
  },
  "design": {
    "colors": {
      "primary": "#7c62c8",
      "accent": "#4f9cf9"
    },
    "theme": {
      "default": "dark",
      "allowed": ["light", "dark", "pure-black"]
    }
  },
  "relays": {
    "defaultRelays": [
      "wss://nos.lol/",
      "wss://relay.primal.net/",
      "wss://offchain.pub/",
      "wss://relay.ditto.pub/"
    ]
  },
  "features": {
    "imageUploads": false
  }
}
